/* eslint-disable react/prop-types */
import Features from "views/Settings/General/components/Features/Features";
import Identity from "views/Settings/General/components/Identity/Identity";
import Transfers from "../../Settings/Accounting/components/Accounting";
import Payment from "../../Settings/General/components/Payments/Payment";
import Formats from "../../Settings/General/components/Formats/Formats";
import Vats from "../../Settings/Accounting/components/Vats";
import { ApolloQueryResult } from "@apollo/client";
import { FaCheckCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { FaCreditCard } from "react-icons/fa";
import { FaBuilding } from "react-icons/fa";
import Welcome from "../components/Welcome";
import { FaFileAlt } from "react-icons/fa";
import { FaThLarge } from "react-icons/fa";
import { FaPercent } from "react-icons/fa";
import Finish from "../components/Finish";
import Loading from "components/Loading";
import { FaHome } from "react-icons/fa";
import { FaBook } from "react-icons/fa";

interface StepContentProps {
  loading: boolean;
  children: React.ReactNode;
}

const StepContent: React.FC<StepContentProps> = ({ loading, children }) => {
  if (loading) {
    return <Loading />;
  }
  return <>{children}</>;
};

export const useSetupSteps = (
  next: () => void,
  prev: () => void,
  mainAddress: any,
  refetch: (
    variables?: Partial<GetVarTypeID> | undefined,
  ) => Promise<ApolloQueryResult<GetCompanySettingResponse>>,
  loading: boolean,
  companySettingLoading: boolean,
) => {
  const { t } = useTranslation();

  return [
    {
      title: t("Welcome"),
      description: t("Get started"),
      icon: <FaHome />,
      content: (
        <StepContent loading={loading || companySettingLoading}>
          <Welcome nextButton={next} />
        </StepContent>
      ),
    },
    {
      title: t("Company"),
      description: t("Company info"),
      icon: <FaBuilding />,
      content: (
        <StepContent loading={loading || companySettingLoading}>
          <Identity isSetup={true} mainAddress={mainAddress} nextButton={next} prevButton={prev} />
        </StepContent>
      ),
    },
    {
      title: t("Payments"),
      description: t("Payment methods"),
      icon: <FaCreditCard />,
      content: (
        <StepContent loading={loading || companySettingLoading}>
          <Payment isSetup={true} nextButton={next} prevButton={prev} />
        </StepContent>
      ),
    },
    {
      title: t("Formats"),
      description: t("Document formats"),
      icon: <FaFileAlt />,
      content: (
        <StepContent loading={loading || companySettingLoading}>
          <Formats isSetup={true} refetch={refetch} nextButton={next} prevButton={prev} />
        </StepContent>
      ),
    },
    {
      title: t("Features"),
      description: t("Enable features"),
      icon: <FaThLarge />,
      content: (
        <StepContent loading={loading || companySettingLoading}>
          <Features isSetup={true} nextButton={next} prevButton={prev} />
        </StepContent>
      ),
    },
    {
      title: t("Vats"),
      description: t("Tax rates"),
      icon: <FaPercent />,
      content: (
        <StepContent loading={loading || companySettingLoading}>
          <Vats isSetup={true} nextButton={next} prevButton={prev} />
        </StepContent>
      ),
    },
    {
      title: t("Accounting"),
      description: t("Accounting setup"),
      icon: <FaBook />,
      content: (
        <StepContent loading={loading || companySettingLoading}>
          <Transfers isSetup={true} nextButton={next} prevButton={prev} />
        </StepContent>
      ),
    },
    {
      title: t("Finish"),
      description: t("All done"),
      icon: <FaCheckCircle />,
      content: (
        <StepContent loading={loading || companySettingLoading}>
          <Finish />
        </StepContent>
      ),
    },
  ];
};
